var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 139,
    viewBox: "0 0 139 139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AVATAR_01",
    "data-name": "AVATAR 01",
    transform: "translate(3 2.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AVATAR_01-2",
    "data-name": "AVATAR 01",
    transform: "translate(0 0.196)",
    fill: "#1c1d1e",
    stroke: "#484848",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 66.5,
    r: 66.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 66.5,
    r: 68,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "add-user",
    transform: "translate(16.329 28.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15042",
    "data-name": "Path 15042",
    d: "M22.86,70.827h39.1a15.653,15.653,0,1,0,9.988-24.593,26.781,26.781,0,0,0-14.6-11.024A18.649,18.649,0,1,0,32.188,27.3,18.861,18.861,0,0,0,40.1,35.21,26.775,26.775,0,0,0,21.258,60.745v8.386a1.672,1.672,0,0,0,1.6,1.7ZM71.574,49.721A12.341,12.341,0,1,1,62.34,61.593,12.119,12.119,0,0,1,71.574,49.721ZM33.413,18.815A15.312,15.312,0,1,1,48.677,34.079,15.281,15.281,0,0,1,33.413,18.815Zm-8.857,41.93A23.525,23.525,0,0,1,48.018,37.283h1.6a23.539,23.539,0,0,1,19.128,9.894,15.7,15.7,0,0,0-9.611,14.416,16.961,16.961,0,0,0,1.131,5.936H24.556Z",
    transform: "translate(0 0)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15043",
    "data-name": "Path 15043",
    d: "M256.186,285.452H260.9v4.711a1.7,1.7,0,1,0,3.392,0v-4.711H269a1.7,1.7,0,0,0,0-3.392h-4.711v-4.617a1.7,1.7,0,1,0-3.392,0v4.617h-4.711a1.7,1.7,0,1,0,0,3.392Z",
    transform: "translate(-187.91 -222.163)",
    fill: "gray"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAvatar);
export default __webpack_public_path__ + "static/media/empty-avatar.1fa323b3.svg";
export { ForwardRef as ReactComponent };